// extracted by mini-css-extract-plugin
module.exports = {"main":"TaxCalculator_main__3thxU","title":"TaxCalculator_title__1aTd7"};